import { render, staticRenderFns } from "./docket.vue?vue&type=template&id=4b720caa&scoped=true&"
import script from "./docket.vue?vue&type=script&lang=js&"
export * from "./docket.vue?vue&type=script&lang=js&"
import style0 from "./docket.vue?vue&type=style&index=0&id=4b720caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b720caa",
  null
  
)

component.options.__file = "docket.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBadge,
  VBtn,
  VCard,
  VDataTable,
  VFlex,
  VIcon,
  VTooltip,
})
